import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import { useAppDispatch } from "../../../hooks/useRedux";
import { Box, Typography, useTheme } from "@mui/material";
import { ICompanyDto } from "../../../types/company";
import useSWRMutation from "swr/mutation";
import { fetcherPost } from "../../../services/fetcher";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../redux/features/snackbarSlice";
import MobileHeader from "../../layout/OwnerLayout/Header";
import BazargahSupportInfo from "./BazargahSupportInfo";
import CustomInput from "../../components/CustomInput";
import SearchSVG from "../../../media/images/icons/search";
import { DotLoader } from "react-spinner-overlay";
import EmptyCargoSVG from "../../../media/images/icons/empty-cargo";
import phoneRing from "../../../media/images/icons/phoneRing.svg";
import { blueGrey } from "@mui/material/colors";
import CompanyInfoBox from "./CompanyInfoBox";

export default function CommunicateCompanies() {
  const [companies, setCompanies] = useState<ICompanyDto[]>([]);

  const [companyValue, setCompanyValue] = useState("");

  const theme = useTheme();

  const dispatch = useAppDispatch();

  const [pageN, setPageN] = useState(1);
  const [pageCounts, setPageCounts] = useState(0);

  const { ref, inView } = useInView({
    /* Optional options */
    threshold: 0,
  });

  const {
    trigger: getCompaniesTrigger,
    isMutating: isgetCompaniesTriggerMutating,
  } = useSWRMutation(
    [`/Society/SearchSociety`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: async (data) => {
        setCompanies(data.data);
        setPageCounts(data.count);
      },
    }
  );
  const {
    trigger: getCompaniesTriggerNextPage,
    isMutating: isgetCompaniesTriggerMutatingNextPage,
  } = useSWRMutation(
    [`/Society/SearchSociety`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: (data) => {
        setCompanies([...companies, ...data.data]);
      },
    }
  );

  useEffect(() => {
    if (companyValue) {
      const timer = setTimeout(() => {
        getCompaniesTrigger({
          filter: [
            {
              colId: "CompanyName",
              filter: companyValue,
              filterType: "text",
              type: "contains",
            },
          ],
          pageNr: 1,
          rowsPerPage: 10,
          sort: [],
        })
          .then((data) => {
            setCompanies(data.data);
          })
          .catch((e) => {
            console.log(e);
          });
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      getCompaniesTrigger({
        filter: [
          {
            colId: "CompanyName",
            filter: "",
            filterType: "text",
            type: "contains",
          },
        ],
        pageNr: 1,
        rowsPerPage: 10,
        sort: [],
      });
    }
  }, [companyValue]);

  useEffect(() => {
    if (inView && pageCounts > companies.length) {
      setPageN((prev) => prev + 1);
    }
  }, [inView]);

  useEffect(() => {
    getCompaniesTriggerNextPage({
      pageNr: pageN,
    });
  }, [pageN]);

  return (
    <>
      <MobileHeader
        title={
          <Typography
            sx={{
              fontWeight: 700,
              color: "secondary.main",
              fontSize: 16,
            }}
          >
            ارتباط با شرکت‌ها{" "}
          </Typography>
        }
      />
      <Box
        sx={{
          paddingX: "8px",
        }}
      >
        <BazargahSupportInfo />
        <Box
          sx={{
            mt: 2,
            paddingX: "8px",
            paddingY: "8px",
            borderRadius: "16px",
            backgroundColor: "background.default",
          }}
        >
          <Box
            sx={{
              paddingY: "16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "6px",
            }}
          >
            <img src={phoneRing} alt="" />
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "700",
                fontSize: "18px",
              }}
            >
              اطلاعات تماس و ارتباط با شرکت‌ها
            </Typography>
          </Box>
          <Typography
            sx={{
              fontSize: "14px",
            }}
          >
            شما می‌توانید با جستجو نام شرکت ، اطلاعات تماس با شرکت مدنظر خود را
            پیدا کنید.
          </Typography>
          <Box
            sx={{
              mt: 2,
            }}
          >
            <CustomInput
              name={"smartCard"}
              value={companyValue}
              handelChange={(e) => setCompanyValue(e.target.value)}
              // error={loaderInfoFormik.touched.smartCard && Boolean(loaderInfoFormik.errors.smartCard)}
              // errorMessage={loaderInfoFormik.tuch}
              placHolder="جستجو شرکتها"
              // disabled={smartCard.disabled}
              endAdornment={<SearchSVG color={theme.palette.primary.main} />}
            />
          </Box>
        </Box>

        {isgetCompaniesTriggerMutating ? (
          <Box
            sx={{
              flex: "1",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                height: "200px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "16px",
              }}
            >
              <DotLoader color={theme.palette.primary.main} />
              <Typography>لطفا منتظر باشید...</Typography>
            </Box>
          </Box>
        ) : companies.length ? (
          companies.map((item, index) => (
            <>
              <CompanyInfoBox
                ref={index + 1 === pageN * 10 ? ref : null}
                {...item}
              />

              {isgetCompaniesTriggerMutatingNextPage &&
                index === companies.length - 1 && (
                  <Box
                    sx={{
                      minHeight: "200px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "16px",
                    }}
                  >
                    <DotLoader color={theme.palette.primary.main} />
                    <Typography>لطفا منتظر باشید...</Typography>
                  </Box>
                )}
            </>
          ))
        ) : (
          <Box
            sx={{
              height: "200px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "16px",
            }}
          >
            <EmptyCargoSVG size={125} color={theme.palette.primary.main} />
            <Typography
              maxWidth={150}
              textAlign={"center"}
              sx={{
                fontWeight: "700",
                color: blueGrey[500],
              }}
            >
              شرکتی یافت نشد!
            </Typography>
          </Box>
        )}
      </Box>
    </>
  );
}
